import { Component } from '@angular/core';
import { GeneralService } from '../../Services/generalservice.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-candidate-dashboard',
  templateUrl: './candidate-dashboard.component.html',
  styleUrls: ['./candidate-dashboard.component.scss']
})
export class CandidateDashboardComponent {
    HomeUrl: any;
    LoginDetails: any;
    countdata: any;

    constructor(public generalservice: GeneralService, private http: HttpClient,
        private router: Router) {
        this.http.get('../assets/WebService.json').subscribe((data: any) => {
            this.HomeUrl = data.Webservice;
        });
        debugger
        this.LoginDetails = JSON.parse(localStorage.getItem("userDetails"));
    }
    ngOnInit() {
        this.appliedcount();
       
    }
    appliedcount() {
        var uploadfile = new FormData();
        uploadfile.append("Count", this.LoginDetails.RegId);
        var url = "api/Njobs/Get_appliedJobs_count";
        this.generalservice.PostData(url, uploadfile).then(data => {
            debugger
            this.countdata = data;
        })
    }
}
